<div class="p-4">
  <mat-dialog-content>
    @if (!loading()) {
      <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between gap-2">
          @switch (type()) {
            @case (modalType.ManualCreation) {
              <h3>{{ "appointments.headings.create" | translate }}</h3>
            }
            @case (modalType.BindToExisting) {
              <h3>{{ "appointments.headings.bind" | translate }}</h3>
            }
            @case (modalType.Cancel) {
              <h3>{{ "appointments.headings.cancel" | translate }}</h3>
            }
          }
        </div>

        <form [formGroup]="createAppointmentForm">
          <mat-form-field class="w-full">
            <mat-label>{{ "appointments.labels.type" | translate }}</mat-label>
            <input
              matInput
              readonly
              [type]="'text'"
              [value]="'medicalServices.prescriptionTypes.' + fc.appointmentType.value | translate"
            />
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>{{ "appointments.labels.name" | translate }}</mat-label>
            <input
              matInput
              readonly
              [type]="'text'"
              [value]="fc.appointmentName.value || 'Не вказано назву послуги'"
            />
          </mat-form-field>

          @if (type() !== modalType.Cancel) {
            <mat-form-field class="w-full">
              <mat-label>{{ "appointments.labels.partnerName" | translate }}</mat-label>
              <mat-select [formControl]="fc.partnerId">
                @for (partner of partnerOptions(); track partner.id) {
                  <mat-option
                    [value]="partner.id"
                    (click)="selectPartner(partner)"
                  >
                    {{ partner.name }}
                  </mat-option>
                }
              </mat-select>
              @if (fc.partnerId.invalid && fc.partnerId.touched) {
                <mat-error>{{ "validation.error.required" | translate }}</mat-error>
              }
            </mat-form-field>

            @if (type() === modalType.BindToExisting) {
              @if (fc.partnerId.value) {
                <div>
                  <hm-suggestions-list
                    [userId]="data.userId"
                    [partnerId]="fc.partnerId.value"
                    (suggestionSelected)="selectSuggestion($event)"
                  ></hm-suggestions-list>
                </div>
              } @else {
                <div class="bg-gray-50 text-gray-600 mt-4 rounded-lg p-4 text-center">
                  {{ "appointments.descriptions.selectPartnerFirst" | translate }}
                </div>
              }
            } @else {
              <mat-form-field class="w-full">
                <mat-label>{{ "appointments.labels.departmentName" | translate }}</mat-label>
                <mat-select [formControl]="fc.locationId">
                  @for (location of locationOptions(); track location.id) {
                    <mat-option
                      [value]="location.id"
                      (click)="selectLocation(location)"
                    >
                      {{ location.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (fc.locationId.invalid && fc.locationId.touched) {
                  <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ "appointments.labels.doctorName" | translate }}</mat-label>
                <input
                  matInput
                  [type]="'text'"
                  [formControl]="fc.doctorName"
                  [matAutocomplete]="doctorsAutocomplete"
                />
                <mat-autocomplete
                  #doctorsAutocomplete
                  (optionSelected)="selectDoctor($event.option.value)"
                >
                  @for (doctor of doctorOptions(); track doctor.id) {
                    <mat-option [value]="doctor">
                      {{ doctor.fullName }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (fc.doctorName.invalid && fc.doctorName.touched) {
                  <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                }
              </mat-form-field>

              <div class="flex w-full gap-4">
                <mat-form-field>
                  <mat-label>{{ "appointments.labels.date" | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="datepicker"
                    [formControl]="fc.date"
                  />
                  <mat-datepicker #datepicker />
                  <mat-datepicker-toggle
                    [for]="datepicker"
                    matSuffix
                  />
                  @if (fc.date.invalid && fc.date.touched) {
                    <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>з</mat-label>
                  <input
                    matInput
                    [matTimepicker]="fromTimepicker"
                    [formControl]="fc.startTime"
                  />
                  <mat-timepicker #fromTimepicker />
                  <mat-timepicker-toggle
                    matSuffix
                    [for]="fromTimepicker"
                  />

                  @if (fc.startTime.invalid && fc.startTime.touched) {
                    <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>до</mat-label>
                  <input
                    matInput
                    [matTimepicker]="toTimepicker"
                    [formControl]="fc.endTime"
                  />
                  <mat-timepicker #toTimepicker />
                  <mat-timepicker-toggle
                    matSuffix
                    [for]="toTimepicker"
                  />
                  @if (fc.startTime.invalid && fc.startTime.touched) {
                    <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                  }
                </mat-form-field>
              </div>

              <mat-form-field class="w-full">
                <mat-label>Вартість послуги (грн)</mat-label>
                <input
                  matInput
                  type="number"
                  min="0"
                  step="0.01"
                  [formControl]="fc.price"
                />
                @if (fc.price.invalid && fc.price.touched) {
                  <mat-error>{{ "validation.error.required" | translate }}</mat-error>
                }
              </mat-form-field>
            }
          } @else {
            <shared-warning-message
              [text]="'appointments.descriptions.cancellationWarning' | translate: { partner: partnerName(), locations: address() }"
              [subText]="'appointments.descriptions.cancellationDetails' | translate: { dateTime: startDate() }"
            ></shared-warning-message>
          }
        </form>
      </div>
    } @else {
      <div class="flex items-center justify-center">
        <shared-loader></shared-loader>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="gap-4">
    @switch (type()) {
      @case (modalType.Cancel) {
        <button
          class="btn btn-primary"
          [type]="'button'"
          (click)="submit()"
        >
          {{ "prescription.actions.cancelAppointment" | translate }}
        </button>
      }
      @default {
        <button
          class="btn btn-secondary"
          mat-dialog-close
          [type]="'button'"
        >
          {{ "buttons.cancel" | translate }}
        </button>
        <button
          class="btn btn-primary"
          [type]="'button'"
          [disabled]="createAppointmentForm.invalid"
          (click)="submit()"
        >
          {{ "buttons.confirm" | translate }}
        </button>
      }
    }
  </mat-dialog-actions>
</div>
